import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';

import ConfirmationCard from '../../components/Shared/ConfirmationCardMultiActionsCard';
import TitleComponent from '../../components/Shared/TitleMultiActionsCard';

import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';

const BodyText = styled.span`
    color: #333;

    a {
        color: #ff245e;
        text-decoration: none;
    }
`;

const ElectionLinkComponent = props => (
    <BodyText>
        <br />
        {props.address}
        <br />
        <br />
        <a target="_blank" href={props.link} rel="noopener noreferrer">
            Learn more
        </a>{' '}
        about elections and voting rights for your state here.
    </BodyText>
);

ElectionLinkComponent.propTypes = {
    link: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired
};

const NotRegisteredComponent = props => (
    <BodyText>
        <br />
        {props.unconfirmedAddress}
        <br />
        <br />
        {props.isMultiCard &&
            `However, if you just registered within the last 4-6 weeks you may not yet be reflected in our partners records.`}
        Register to vote and make your voice heard in upcoming elections!
    </BodyText>
);

NotRegisteredComponent.propTypes = {
    unconfirmedAddress: PropTypes.string,
    isMultiCard: PropTypes.bool
};

const CheckRegistrationSuccessMultiActionCard = props => (
    <TransitionContainerNoExit>
        {props.isRegistered ? (
            <ConfirmationCard
                thankYouText=""
                titleComponent={
                    <TitleComponent
                        titleNoRep={`You’re all set, ${
                            props.confirmedFirstName
                        }. Our system confirms you are registered to vote at:`}
                    />
                }
                bodyComponent={
                    <ElectionLinkComponent
                        address={props.confirmedAddress}
                        link={props.specificStateInfoLink}
                    />
                }
                {...props}
            />
        ) : (
            <ConfirmationCard
                thankYouText=""
                titleComponent={
                    <TitleComponent
                        titleNoRep={`We cannot confirm your registration at:`}
                    />
                }
                bodyComponent={
                    <NotRegisteredComponent
                        isMultiCard={props.isMultiCard}
                        unconfirmedAddress={props.unconfirmedAddress}
                    />
                }
                {...props}
            />
        )}
    </TransitionContainerNoExit>
);

CheckRegistrationSuccessMultiActionCard.propTypes = {
    isRegistered: PropTypes.bool,
    confirmedFirstName: PropTypes.string,
    confirmedAddress: PropTypes.string,
    unconfirmedAddress: PropTypes.string,
    registerButtonText: PropTypes.string,
    specificStateInfoLink: PropTypes.string,
    currentAction: PropTypes.object,
    isMultiCard: PropTypes.bool
};

export default connect(
    state => ({
        isRegistered: state.checkRegistration.completeCheckRegistration.isRegistered,
        registerButtonText: `REGISTER`,
        confirmedFirstName: state.form.checkRegistrationForm.values.firstName,
        confirmedAddress:
            state.checkRegistration.completeCheckRegistration.confirmedAddress,
        unconfirmedAddress: `${state.form.checkRegistrationForm.values.address} ${
            state.form.checkRegistrationForm.values.homeCity
        }, ${state.form.checkRegistrationForm.values.stateId} ${
            state.form.checkRegistrationForm.values.postalCode
        }`,
        specificStateInfoLink:
            state.checkRegistration.completeCheckRegistration.specificStateInfoLink,
        currentAction: state.widget.activeAction,
        isMultiCard: state.widget.actions > 1
    }),
    {}
)(CheckRegistrationSuccessMultiActionCard);
